export const UPSERT_LOCATION_AVAILABILITY_OVERRIDE = `
  mutation UpsertLocationAvailabilityOverride(
    $id: ID
    $locationId: ID!
    $overrideDate: ISO8601Date!
    $enabled: Boolean
    $blocks: String
  ) {
    upsertLocationAvailabilityOverride(
      id: $id
      locationId: $locationId
      overrideDate: $overrideDate
      enabled: $enabled
      blocks: $blocks
    ) {
      result
      errors
      locationAvailabilityOverride {
        id
        overrideDate
        enabled
        blocks
      }
    }
  }
`

export const isPendingOverrideId = (id) => String(id).startsWith("pending:")

export const buildLocalOverride = (draft) => {
  const blocks = JSON.stringify([{ starts_at: draft.startsAt, ends_at: draft.endsAt }])
  return {
    id: `pending:${draft.overrideDate}`,
    overrideDate: draft.overrideDate,
    enabled: draft.enabled,
    blocks
  }
}

export async function persistLocationAvailabilityOverrides(upsertOverride, locationId, overrides) {
  const saved = []

  for (const override of overrides || []) {
    const result = await upsertOverride({
      id: isPendingOverrideId(override.id) ? undefined : override.id,
      locationId,
      overrideDate: override.overrideDate,
      enabled: override.enabled,
      blocks: override.blocks
    })

    if (result.data?.upsertLocationAvailabilityOverride?.result === "success") {
      const savedRow = result.data.upsertLocationAvailabilityOverride.locationAvailabilityOverride
      saved.push({ ...savedRow, blocks: override.blocks })
    } else {
      const errors = result.data?.upsertLocationAvailabilityOverride?.errors?.join(", ")
      throw new Error(errors || "Could not save special date")
    }
  }

  return saved
}
